<template>
  <div>
    <el-dialog :visible.sync="logDialogVisible" title="操作日志" width="60%" :modal-append-to-body="false"
      @close="handleClose">
      <el-table height="500" :data="list" border>
        <!-- <el-table-column prop="id" label="序号" width="80"></el-table-column> -->
        <el-table-column prop="time" label="操作时间"></el-table-column>
        <el-table-column prop="operator" label="操作人"></el-table-column>
        <el-table-column prop="type" label="操作类型">
          <!-- 操作类型：1新增 2修改 3删除 4上线 5下线 -->
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">新增</span>
            <span v-if="scope.row.type === 2">修改</span>
            <span v-if="scope.row.type === 3">删除</span>
            <span v-if="scope.row.type === 4">上线</span>
            <span v-if="scope.row.type === 5">下线</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="updateInfo" label="修改内容"></el-table-column>
      </el-table>
      <!-- //^ ^--------------分页组件-------------^ ^ -->
      <ElementPagination :current-page="searchParams.current" :page-size="searchParams.size" :total="searchParams.total"
        :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      <!-- 关闭按钮 -->
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="handleClose">关闭</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Message from "@/components/Message";
import ElementPagination from "@/components/ElementPagination";
import { logPageApi } from "@/api/mediaManage/mediaContentManage.js"
export default {
  name: "WebSassMemberRightLog",
  components: {
    ElementPagination
  },
  props: {
    /** 记录的id */
    id: {
      type: Number,
      default: 0
    },
  },
  watch: {
    logDialogVisible(newVal) {
      if (newVal) {
        console.log("拿到的id", this.id);
        /** 修正分页参数 */
        this.searchParams.subjectId = this.id;
        /** 获取操作日志 */
        this.getLogList();
      }
    }
  },
  data() {
    return {
      logDialogVisible: false,
      list: [],
      /** 分页参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: 50,
        /** 记录id */
        subjectId: "",
        /** 模块 */
        module:"",
      }
    };
  },

  methods: {
    /** 查询操作日志的接口 */
    async getLogList() {
      console.log("分页参数", this.searchParams);
      const { data } = await logPageApi(this.searchParams)
      console.log('获取操作日志的响应', data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
    },
    show(id,type) {
      console.log('传递过来的id,type', id,type);
      this.id = id;
      this.searchParams.module = type;
      this.logDialogVisible = true;
    },
    /** 对话框关闭 */
    hide() {
      this.logDialogVisible = false;
      /** 关闭之后清空数据 */
      this.list = [];
    },
    //^ ^--------------分页相关 start-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      this.getLogList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      this.getLogList();
    }
    //^ ^--------------分页相关 end-------------^ ^
  }
};
</script>

<style lang="scss" >
.el-tooltip__popper {
  max-width: 80%;
}
</style>
